export default __webpack_public_path__ + "static/media/sc.3fce1b56.svg";